import { Link } from "react-router-dom";

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="text-2xl font-bold text-[#1a1a1a]" style={{ fontFamily: "'Outfit', sans-serif" }}>
      {title}
    </h2>
    <div className="space-y-3 text-gray-600 leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      {children}
    </div>
  </section>
);

const PrivacyPolicyPage = () => {
  return (
    <div className="page-fade-in">
      <section className="bg-[#EEF8F2] text-[#1a1a1a] border-b border-[#42D78A]/20 py-20 md:py-24 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-[#42D78A] text-sm tracking-[0.2em] uppercase mb-4 font-medium" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            614 Shop Local
          </p>
          <h1 className="text-4xl sm:text-5xl font-bold mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Privacy Policy
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Last updated June 14, 2026
          </p>
        </div>
      </section>

      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto space-y-10">
          <div className="rounded-2xl border border-gray-100 bg-gray-50 p-6">
            <p className="text-gray-600 leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              This Privacy Policy explains how 614 Shop Local collects, uses, and protects information when you use our website, directory, account features, newsletter forms, and related services.
            </p>
          </div>

          <Section title="Information We Collect">
            <p>
              We collect information you choose to provide, including names, email addresses, business names, market names, descriptions, addresses, neighborhoods or locations, phone numbers, websites, social media links, schedules, event details, uploaded logos or images, contact form messages, sponsorship inquiries, and newsletter signup information.
            </p>
            <p>
              If you create a shopper profile, we collect your email address, optional name, and the businesses or markets you save or follow. If you log in, we use one-time verification codes and authentication tokens to help protect account access.
            </p>
          </Section>

          <Section title="Public Directory Information">
            <p>
              Business, market, and event listing information is intended to be shown publicly in the directory or upcoming events areas. This may include your listing name, description, general location, address, schedule, website, social media links, logo, and other details you submit for display.
            </p>
          </Section>

          <Section title="How We Use Information">
            <p>
              We use information to create and manage accounts, display directory listings, publish market and event details, send login verification codes, respond to messages, review submissions, send newsletter or merch launch updates, manage saved businesses and followed markets, and improve the platform.
            </p>
          </Section>

          <Section title="Email and Notifications">
            <p>
              We may send transactional emails, login verification codes, account-related notices, listing updates, inquiry responses, and newsletter messages. Newsletter subscribers are added to our Mailtrap newsletter list when that integration is configured.
            </p>
          </Section>

          <Section title="Third-Party Services">
            <p>
              We use third-party tools to operate the site, including hosting, database, email delivery, file storage, analytics or monitoring tools if enabled, and external services such as Mailtrap for email and contact list management. Some links may take you to third-party websites such as Instagram, Facebook, Discord, or business and market websites.
            </p>
          </Section>

          <Section title="Local Storage and Login Tokens">
            <p>
              The site may store authentication tokens and basic account information in your browser&apos;s local storage so you can stay logged in. You can clear this information by logging out or clearing your browser storage.
            </p>
          </Section>

          <Section title="How We Share Information">
            <p>
              We do not sell personal information. We share information when needed to operate the site, publish directory listings you submit, work with service providers, comply with legal obligations, protect the platform, or respond to your requests.
            </p>
          </Section>

          <Section title="Data Choices">
            <p>
              You may contact us to request updates, corrections, or removal of your account or listing information. Some information may remain in backups, logs, or records where needed for security, legal, or operational reasons.
            </p>
          </Section>

          <Section title="Children">
            <p>
              614 Shop Local is not intended for children under 13. We do not knowingly collect personal information from children under 13.
            </p>
          </Section>

          <Section title="Contact Us">
            <p>
              Questions about this Privacy Policy can be sent to{" "}
              <a href="mailto:hello@614shoplocal.com" className="font-bold text-[#1a1a1a] hover:text-[#42D78A]">
                hello@614shoplocal.com
              </a>
              .
            </p>
            <p>
              You can also reach us through the <Link to="/contact" className="font-bold text-[#1a1a1a] hover:text-[#42D78A]">contact page</Link>.
            </p>
          </Section>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
